import { useScopedSelector } from 'ia-react-core';
import { AvailableDocumentGroup } from '../interfaces/AvailableDocumentGroup';
import { DocumentSummary } from '../interfaces/DocumentSummary';

export default function useDocumentSummary(): DocumentSummary {
  const documentSummary: DocumentSummary = useScopedSelector('/App.features.documents.documentsSummary');
  const availables: AvailableDocumentGroup[] = useScopedSelector('/App.features.documents.available');
  return {
    isVisible: documentSummary?.isVisible && availables && availables.length !== 0 && availables.every((x) => x.documents.length !== 0),
    documentsCount: documentSummary?.documentsCount,
  };
}
